import React, { useState, ReactNode } from 'react';

import { createContext, useContext } from 'use-context-selector';
import { Specialist, FilterItems, SpecialistList } from '../models/Specialist';
import { Specialty } from '../models/Specialty';
import { accentsTidy } from '../utils/masks';

export type Filters = {
  units: string[];
  expertise: string[];
  medicalField: string[];
};

export type SpecialistContextProps = {
  specialists: SpecialistList[] | null;
  setSpecialists: (list: SpecialistList[]) => void;
  selectedSpecialist: Specialist | undefined;
  setSelectedSpecialist: (specialist: Specialist | undefined) => void;
  selectedSpecialty: Specialty | undefined;
  setSelectedSpecialty: (specialty: Specialty | undefined) => void;
  listUnitsFilter: FilterItems[];
  setListUnitsFilter: (newListUnitsFilter: FilterItems[]) => void;
  specialties: Specialty[];
  setSpecialties: (specialties: Specialty[]) => void;
  findSpecialties: (name: string) => Specialty[];
  clearSpecialistConntext: () => void;
  selectedFilters: Filters;
  handleCleanSelectedFilters(): void;
  setSelectedFilters: (filters: Filters) => void;
  valueFilter: string;
  setValueFilter: (value: string) => void;
};

type SpecialistProviderProps = {
  children: ReactNode;
};

export const SpecialistContext = createContext({} as SpecialistContextProps);

export function SpecialistProvider({ children }: SpecialistProviderProps) {
  const [specialists, setSpecialists] = React.useState<SpecialistList[] | null>(null);
  const [selectedSpecialist, setSelectedSpecialist] = useState<Specialist>();
  const [specialties, setSpecialties] = useState<Specialty[]>([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState<Specialty>();
  const [listUnitsFilter, setListUnitsFilter] = useState<FilterItems[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<Filters>({ expertise: [], medicalField: [], units: [] });
  const [valueFilter, setValueFilter] = React.useState('');

  function handleCleanSelectedFilters() {
    setSelectedFilters({ expertise: [], medicalField: [], units: [] });
  }

  function findSpecialties(name: string) {
    return specialties?.filter(item => accentsTidy(item.name).toUpperCase().includes(accentsTidy(name).toUpperCase()));
  }

  const clearSpecialistConntext = () => {
    setValueFilter('');
    setSpecialties([]);
    setListUnitsFilter([]);
    // setSpecialists(null);
    setSelectedSpecialist(undefined);
  };

  return (
    <SpecialistContext.Provider
      value={{
        specialists,
        setSpecialists,
        selectedSpecialist,
        setSelectedSpecialist,
        selectedSpecialty,
        setSelectedSpecialty,
        listUnitsFilter,
        setListUnitsFilter,
        specialties,
        setSpecialties,
        findSpecialties,
        clearSpecialistConntext,
        selectedFilters,
        handleCleanSelectedFilters,
        setSelectedFilters,
        valueFilter,
        setValueFilter
      }}
    >
      {children}
    </SpecialistContext.Provider>
  );
}

export function useSpecialistContext() {
  return useContext(SpecialistContext);
}
